module.exports = __webpack_public_path__ + "img/ylcd.ea8f0ca0.png";